<template>
<form class="check_multiple_send" :inert="isLoading" :class="{ 'ajax_processed': isLoading }" @submit.prevent="onSubmit">
    <div class="form_row required" :class="{ 'error': v$.formData.name.$errors.length }">
        <label for="renter-name">Ваше имя<span class="req">*</span></label>
        <input id="renter-name" type="text" v-model="formData.name">
    </div>
    <div class="form_row required" :class="{ 'error': v$.formData.phone.$errors.length }">
        <label for="renter-phone">Телефон<span class="req">*</span></label>
        <input id="renter-phone" type="text" inputmode="tel" v-model="formData.phone" placeholder="+7 (___) ___-__-__" data-mask-phone>
    </div>
    <div class="form_row required" :class="{ 'error': v$.formData.email.$errors.length }">
        <label for="renter-email">E-mail<span class="req">*</span></label>
        <input id="renter-email" type="email" v-model="formData.email">
    </div>
    <div class="form_row  required" :class="{ 'error': v$.formData.address.$errors.length }">
        <label for="renter-address">Адрес помещения: Область, Город, Улица, Дом<span class="req">*</span></label>
        <input id="renter-address" type="text" v-model="formData.address">
    </div>
    <div class="form_row  required" :class="{ 'error': v$.formData.space.$errors.length }">
        <label for="renter-space">Площадь помещения<span class="req">*</span></label>
        <input id="renter-space" type="text" v-model="formData.space">
    </div>
    <div class="form_row">
        <label for="renter-cost">Желаемая стоимость аренды объекта</label>
        <input id="renter-cost" type="text" v-model="formData.preferedCost">
    </div>
    <div class="form_row">
        <label for="renter-comment">Комментарий</label>
        <textarea id="renter-comment" v-model="formData.comment"></textarea>
    </div>
    <div class="form_row">
        <label for="renter-file">Файл</label>
        <div class="bl_input_file ">
            <input id="renter-file" ref="renterFile" type="file" class="input-file" @change="onUploadFiles">
            <input type="text" class="filename"> <span>Обзор</span>
        </div>
    </div>
    <div class="consent-accepted" v-if="confirmConsent">Согласие на обработку персональных данных принято</div>

    <div v-if="!confirmConsent" class="confirm-consent">
        <div class="confirm-consent__text">
            Подтвердите <a href="/upload/Согласие.pdf" target="_blank">согласие</a> на обработку <br> Ваших персональных
            данных
        </div>
        <div class="confirm-consent__btn">
            <button class="btn btn_red" type="button" @click="confirmConsent = true">Подтвердить</button>
        </div>
    </div>
    <div v-else class="consent-block">
        <div class="consent-final">
            <div class="consent-final__text">
                Нажимая кнопку, Вы подтверждаете, что ознакомились с <a href="/upload/Политикa-конфиденциальности.pdf"
                    target="_blank">Политикой конфиденциальности</a>
            </div>
            <div class="consent-final__btn">
                <div class="not-theme">
                    <input type="submit" value="Отправить" class="btn btn_red">
                </div>
            </div>
        </div>
    </div>
</form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core'
import { required, email, helpers, minLength } from '@vuelidate/validators'

const { withMessage } = helpers;
import { objectToFormData } from '../../utils/objectToFormData.js';
import initMasks from '../../utils/masks.js';

export default {
    name: 'RenterForm',
    setup() {
        return { v$: useVuelidate(), initMasks }
    },
    data: () => ({
        formData: {
            name: '',
            email: '',
            phone: '',
            address: '',
            space: '',
            preferedCost: '',
            comment: '',
            file: null,
        },
        isLoading: false,
        confirmConsent: false,
    }),
    validations() {
        return {
            formData: {
                name: {
                    required: withMessage('Обязательное поле', required)
                },
                email: {
                    required: withMessage('Обязательное поле', required),
                    email: withMessage('Введите корректный email', email),
                },
                phone: {
                    required: withMessage('Обязательное поле', required),
                    minLength: withMessage('Введите корректный телефон', minLength(18)),
                },
                address: {
                    required: withMessage('Обязательное поле', required),
                },
                space: {
                    required: withMessage('Обязательное поле', required),
                },
            }
        }
    },
    mounted() {
        this.initMasks();
    },
    computed: {
        ...mapGetters({
            getYandexSiteKey: 'getYandexSiteKey',
        })
    },
    watch: {},
    methods: {
        onUploadFiles(event) {
            this.formData.file = event.target.files[0];
        },
        async onSubmit() {
            const isValid = await this.v$.$validate();
            if (!isValid) return
            this.isLoading = true;
            const isCaptchaStarted = await this.executeYandexCaptcha(() => this.sendForm());
            if (!isCaptchaStarted) {
                this.isLoading = false;
                window.showHeaderMessage('Не удалось загрузить проверку. Перезагрузите страницу и попробуйте ещё раз.', 'error');
            }
        },
        clearForm() {
            this.v$.$reset();
            this.formData = {
                name: '',
                email: '',
                phone: '',
                address: '',
                space: '',
                preferedCost: '',
                comment: '',
                file: null,
            };
            this.$refs.renterFile.value = null;
            this.$refs.renterFile.dispatchEvent(new Event('change', { bubbles: true }));
            this.confirmConsent = false;
        },
        async sendForm() {
            try {
                const result = await fetch('/api/forms/renter-feedback/', {
                    method: 'POST',
                    body: objectToFormData({ ...this.formData, yatoken: window.smartCaptcha.getResponse() }),
                });
                const data = await result.json();
                if (data.success) {
                    window.showHeaderMessage('Ваше обращение отправлено');
                    this.clearForm();
                } else {
                    window.showHeaderMessage(data.error || 'Произошла ошибка', 'error');
                }
            } catch (error) {
                window.showHeaderMessage(error || 'Произошла ошибка', 'error');
            } finally {
                this.isLoading = false;
            }
        },
        ...mapActions({
            'executeYandexCaptcha': 'executeYandexCaptcha',
        }),
    },
}
</script>
